(function () {
  const TEXT_FIELDS = [
    'email',
    'first_name',
    'last_name',
    'address',
    'city',
    'state',
    'zipcode',
    'country',
    'phone',
    'sema_booth',
    'events_attending',
    'club_team_name',
    'instagram_handle',
    'youtube_handle',
    'facebook_url',
    'vehicle_year',
    'vehicle_make',
    'vehicle_model',
    'vehicle_submodel',
    'current_sponsors',
    'future_modifications'
  ];

  const FIELD_LABELS = {
    email: 'Email Address',
    first_name: 'First Name',
    last_name: 'Last Name',
    address: 'Address',
    city: 'City',
    state: 'State / Province / Region',
    zipcode: 'Zipcode',
    country: 'Country',
    phone: 'Phone Number',
    sema_booth: 'SEMA Booth #',
    events_attending: 'Events Attending',
    club_team_name: 'Club / Team Name',
    instagram_handle: 'Instagram Handle',
    youtube_handle: 'Youtube Handle',
    facebook_url: 'Facebook URL',
    vehicle_year: 'Vehicle Year',
    vehicle_make: 'Vehicle Make',
    vehicle_model: 'Vehicle Model',
    vehicle_submodel: 'Vehicle Submodel',
    current_sponsors: 'Current Sponsors',
    future_modifications: 'Future Modifications',
    sms_opt_in: 'SMS marketing opt-in',
    confidentiality_agreed: 'Confidentiality agreement'
  };

  const MAX_PHOTO_BYTES = 64 * 1024 * 1024;
  const ALLOWED_MIME_TYPES = {
    'image/jpeg': true,
    'image/png': true,
    'image/webp': true,
    'image/gif': true
  };

  const API_ORIGIN = 'https://support.anzousa.com';
  const SUBMIT_TIMEOUT_MS = 600000;

  function collectFormData(form) {
    const data = {};
    const formData = new FormData(form);

    TEXT_FIELDS.forEach(function (field) {
      const value = formData.get(field);
      if (value && String(value).trim() !== '') {
        data[field] = String(value).trim();
      }
    });

    data.sms_opt_in = !!formData.get('sms_opt_in');
    data.confidentiality_agreed = !!formData.get('confidentiality_agreed');

    return data;
  }

  function buildSummary(data) {
    const lines = [];

    TEXT_FIELDS.forEach(function (field) {
      if (!data[field]) {
        return;
      }
      lines.push((FIELD_LABELS[field] || field) + ': ' + data[field]);
    });

    if (data.sms_opt_in) {
      lines.push((FIELD_LABELS.sms_opt_in || 'sms_opt_in') + ': Yes');
    }

    if (data.confidentiality_agreed) {
      lines.push((FIELD_LABELS.confidentiality_agreed || 'confidentiality_agreed') + ': Yes');
    }

    return lines.join('\n');
  }

  function collectPhotoFiles(form) {
    const files = [];
    const skipped = [];
    const inputs = form.querySelectorAll('[data-sponsorship-photo-input]');

    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i];
      if (!input.files || !input.files[0]) {
        continue;
      }

      const file = input.files[0];
      const label = 'Photo ' + (i + 1) + ' (' + file.name + ')';

      if (!ALLOWED_MIME_TYPES[file.type]) {
        skipped.push(label + ' skipped: must be a JPG, PNG, WEBP, or GIF image.');
        continue;
      }

      if (file.size > MAX_PHOTO_BYTES) {
        skipped.push(label + ' skipped: exceeds the 64 MB size limit.');
        continue;
      }

      files.push({
        field: 'photo_' + (files.length + 1),
        file: file
      });
    }

    return {
      files: files,
      skipped: skipped
    };
  }

  function bindPhotoUploads(root) {
    root.querySelectorAll('[data-sponsorship-photo]').forEach(function (wrap) {
      const input = wrap.querySelector('[data-sponsorship-photo-input]');
      const box = wrap.querySelector('[data-sponsorship-photo-box]');
      const preview = wrap.querySelector('[data-sponsorship-photo-preview]');

      if (!input || !box || !preview) {
        return;
      }

      input.addEventListener('change', function () {
        const file = input.files && input.files[0];

        if (!file) {
          box.classList.remove('has-image');
          preview.removeAttribute('src');
          preview.alt = '';
          return;
        }

        if (!ALLOWED_MIME_TYPES[file.type]) {
          showError(root, 'Please upload JPG, PNG, WEBP, or GIF images only.');
          input.value = '';
          box.classList.remove('has-image');
          preview.removeAttribute('src');
          return;
        }

        hideError(root);
        preview.src = URL.createObjectURL(file);
        preview.alt = file.name;
        box.classList.add('has-image');
      });
    });
  }

  function appendHiddenField(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function parseSubmitMessage(data) {
    if (!data) {
      return null;
    }

    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        return null;
      }
    }

    if (!data || data.type !== 'sponsorship-submit') {
      return null;
    }

    return data;
  }

  function isTrustedSubmitOrigin(origin) {
    if (!origin) {
      return false;
    }

    if (origin === API_ORIGIN) {
      return true;
    }

    try {
      const hostname = new URL(origin).hostname;
      return hostname === 'support.anzousa.com';
    } catch (error) {
      return false;
    }
  }

  function submitApplication(endpointUrl, secret, data, photoFiles) {
    return new Promise(function (resolve, reject) {
      const iframeName = 'sponsorship-submit-' + Date.now();
      const iframe = document.createElement('iframe');
      iframe.name = iframeName;
      iframe.style.display = 'none';
      iframe.setAttribute('aria-hidden', 'true');
      document.body.appendChild(iframe);

      let settled = false;

      function cleanup() {
        window.removeEventListener('message', onMessage);
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      }

      function finishSuccess() {
        if (settled) {
          return;
        }
        settled = true;
        cleanup();
        resolve();
      }

      function finishError(message) {
        if (settled) {
          return;
        }
        settled = true;
        cleanup();
        reject(new Error(message));
      }

      function handleSubmitMessage(event) {
        if (event.source !== iframe.contentWindow) {
          return;
        }

        if (!isTrustedSubmitOrigin(event.origin)) {
          return;
        }

        const payload = parseSubmitMessage(event.data);
        if (!payload) {
          return;
        }

        if (payload.success) {
          finishSuccess();
        } else {
          finishError(payload.message || 'Unable to submit your application. Please try again.');
        }
      }

      function onMessage(event) {
        handleSubmitMessage(event);
      }

      window.addEventListener('message', onMessage);

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = endpointUrl;
      form.enctype = 'multipart/form-data';
      form.target = iframeName;
      form.style.display = 'none';

      appendHiddenField(form, 'secret', secret);
      appendHiddenField(form, 'response_mode', 'iframe');
      appendHiddenField(form, 'summary', data.summary || buildSummary(data));

      TEXT_FIELDS.forEach(function (field) {
        if (data[field]) {
          appendHiddenField(form, field, data[field]);
        }
      });

      if (data.sms_opt_in) {
        appendHiddenField(form, 'sms_opt_in', 'Yes');
      }

      if (data.confidentiality_agreed) {
        appendHiddenField(form, 'confidentiality_agreed', 'Yes');
      }

      photoFiles.forEach(function (photo) {
        const input = document.createElement('input');
        input.type = 'file';
        input.name = photo.field;

        const transfer = new DataTransfer();
        transfer.items.add(photo.file);
        input.files = transfer.files;

        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();

      window.setTimeout(function () {
        if (form.parentNode) {
          form.parentNode.removeChild(form);
        }
      }, 1000);

      window.setTimeout(function () {
        finishError('Submission timed out. Large files can take several minutes. Please try again or use a smaller image.');
      }, SUBMIT_TIMEOUT_MS);
    });
  }

  function showError(root, message) {
    const errorEl = root.querySelector('[data-sponsorship-error]');
    if (errorEl) {
      errorEl.hidden = false;
      errorEl.textContent = message;
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function hideError(root) {
    const errorEl = root.querySelector('[data-sponsorship-error]');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function showSuccess(root) {
    const successEl = root.querySelector('[data-sponsorship-success]');
    const formWrap = root.querySelector('[data-sponsorship-form-wrap]');

    if (formWrap) {
      formWrap.hidden = true;
    }

    if (successEl) {
      successEl.hidden = false;
      successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function setProcessing(root, isProcessing) {
    const overlay = root.querySelector('[data-sponsorship-overlay]');
    const overlayText = root.querySelector('[data-sponsorship-overlay-text]');
    const submitButton = root.querySelector('[data-sponsorship-submit]');

    if (overlay) {
      overlay.hidden = !isProcessing;
      overlay.setAttribute('aria-hidden', isProcessing ? 'false' : 'true');
    }

    document.body.classList.toggle('sponsorship-application--processing', isProcessing);

    if (submitButton) {
      submitButton.disabled = isProcessing;

      if (isProcessing) {
        const loadingText = submitButton.dataset.loadingText || 'Submitting...';

        submitButton.textContent = loadingText;

        if (overlayText) {
          overlayText.textContent = loadingText;
        }
      } else {
        submitButton.textContent = submitButton.dataset.defaultText || 'Submit';
      }
    }
  }

  function initSection(root) {
    const form = root.querySelector('[data-sponsorship-form]');
    if (!form) {
      return;
    }

    bindPhotoUploads(root);

    const submitEndpoint = root.dataset.submitEndpoint;
    const submitSecret = root.dataset.submitSecret;

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      hideError(root);

      const data = collectFormData(form);

      if (!data.email || !data.first_name || !data.last_name) {
        showError(root, 'Please enter your email address, first name, and last name.');
        return;
      }

      if (!data.vehicle_year || !data.vehicle_make || !data.vehicle_model) {
        showError(root, 'Please complete the required vehicle year, make, and model fields.');
        return;
      }

      if (!data.confidentiality_agreed) {
        showError(root, 'Please agree to the confidentiality statement before submitting.');
        return;
      }

      if (!submitEndpoint || !submitSecret) {
        showError(root, 'Sponsorship submission is not configured. Please contact support.');
        return;
      }

      setProcessing(root, true);

      try {
        const photoResult = collectPhotoFiles(form);
        let summary = buildSummary(data);

        if (photoResult.skipped.length > 0) {
          summary +=
            '\n\n--- Photos Skipped ---\n' +
            'These photos were not uploaded because they exceeded limits or were unsupported:\n' +
            photoResult.skipped.join('\n');
        }

        data.summary = summary;
        await submitApplication(submitEndpoint, submitSecret, data, photoResult.files);
        showSuccess(root);
      } catch (error) {
        showError(root, error.message || 'Something went wrong. Please try again.');
      } finally {
        setProcessing(root, false);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-sponsorship-application]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-sponsorship-application]');
    if (root) {
      initSection(root);
    }
  });
})();
